import { Box, Modal, Grid, Typography, IconButton, Divider } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CrmTable from "../../App/Components/Table/CrmTable";
import { Column } from "ka-table/models";
import { DataType } from "ka-table";
import { PaginationState } from "../../App/Components/Table/State/PaginationState";
import { ICandidate } from "../../App/Typings/Candidate";

interface DynamicGroupPreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  isLoading: boolean;
  members: ICandidate[];
  totalMembers: number;
  pagination: PaginationState;
}

const columnNames: Column[] = [
  { title: "Name", key: "fullName", dataType: DataType.String },
  { title: "Tags", key: "tags", dataType: DataType.Object },
  { title: "Phone Numbers", key: "phoneNumbers", dataType: DataType.Object },
  { title: "Email Addresses", key: "emailAddresses", dataType: DataType.Object },
  { title: "Locations", key: "locations", dataType: DataType.Object },
];

export function DynamicGroupPreviewModal({
  isOpen,
  onClose,
  isLoading,
  members,
  totalMembers,
  pagination,
}: DynamicGroupPreviewModalProps) {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="dynamic-group-preview-modal"
      data-test="dynamic-group-preview-modal"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 900,
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: "5px",
          maxHeight: 750,
          pt: 2,
          pb: 4,
          pr: 4,
          pl: 4,
          border: "none",
        }}
      >
        <Grid container>
          <Grid item xs={9}>
            <Typography variant="h5">Previewing Dynamic Group Candidates</Typography>
          </Grid>
          <Grid item xs={3} style={{ textAlign: "right" }}>
            <IconButton onClick={onClose} data-test="dynamic-group-modal-close-btn">
              <CloseIcon />
            </IconButton>
          </Grid>
          <Grid item xs={12} style={{ textAlign: "right" }}>
            <Divider />
            <br />
            {!isLoading ? <>{totalMembers} candidates found</> : <></>}
          </Grid>
          <Grid item xs={12} style={{ maxHeight: "500px", overflowY: "auto" }}>
            <br />
            <CrmTable
              name="dynamic-group-preview"
              data={members}
              loading={isLoading}
              pagination={{
                enabled: !isLoading,
                rowsPerPage: [10, 25, 50, 100],
                currentPage: pagination.getters.page,
                rows: pagination.getters.pageSize,
                handleChangePage: pagination.handlers.handleChangePage,
                handleChangeRowsPerPage: pagination.handlers.handleChangePageSize,
                totalCount: totalMembers,
              }}
              columns={columnNames}
              onSort={pagination.handlers.handleRequestSort}
              order={pagination.getters.sortDirection}
              orderBy={pagination.getters.sortBy}
            />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
